$(document).ready(function () {
    initInputs();
    validateAccountForm();
    activeNav();
});

function initInputs() {
    // Focus in
    var inputs = $('.input-intercaves');
    inputs.focusin(function () {
        $(this).addClass('input-intercaves-focus');
    }); // Focus out

    inputs.focusout(function () {
        checkThisInput(this, true);
    }); // Autofilled

    inputs.on("change paste", function () {
        checkThisInput(this, false);
    }); // Fields already completed

    inputs.each(function () {
        checkThisInput(this, false);
    }); // Same things with selects

    initSelects();
}

function checkThisInput(obj, displayErrors) {
    // Empty value
    if ($(obj).val() === '') {
        // Value required and not filled
        if (displayErrors === true && $(obj).prop('required')) {
            // $(obj).removeClass('valid').addClass('invalid');
        }
        $(obj).removeClass('input-intercaves-focus'); // Not empty value
    } else {
        // Value required and filled
        if (displayErrors === true && $(obj).prop('required')) {
            // $(obj).removeClass('invalid').addClass('valid');
        }
        $(obj).addClass('input-intercaves-focus');
    }
}

function initSelects() {
    var selects = $('.select-phox select');
    selects.focusin(function () {
        $(this).addClass('input-phox-focus');
    });
    selects.focusout(function () {
        // Empty value
        if (!$('option:selected', this)) {
            $(this).removeClass('valid').addClass('invalid');
            $(this).removeClass('input-phox-focus'); // Not empty value
        } else {
            // Value required and filled
            $(this).removeClass('invalid').addClass('valid');
            $(this).addClass('input-phox-focus');
        }
    });
}

function deleteFromWishList(codepro) {
    $.ajax({
        url: "ajaxeshop/removeFromFavorite",
        type: "POST",
        data: {
            codepro: codepro
        },
        success: function (content) {
            var popin = extract_value(content, 'POPIN');
            $('#popin_modal_lg_content').html(popin);
            // on remove tout l'article et ses divs
            $('[data-codepro_moz="' + codepro + '"]').parent().parent().remove();
        }
    });
}

function deleteFromWishListStep(codepro) {

    $('#fav_loader_' + codepro).html($(
        '<div class="favorite-loader">' +
        '<div class="favorite-loader-background"></div>' +
        '<img class="favorite-loader-image" src="/images/loader.gif">' +
        '</div>'
    ));

    setTimeout(function () {
        $.ajax({
            url: "ajaxeshop/removeFromFavorite",
            type: "POST",
            data: {
                codepro: codepro
            },
            success: function (content) {
                $('#fav_item_' + codepro).fadeOut();
                $('#fav_loader_' + codepro).remove();
                console.log(content);
            }
        });
    }, 200);
}

function showNewsletterPopin() {
    var email = $('#input-newsletter').val();

    $.ajax({
        url: "ajaxeshop/showNewsletterPopin",
        type: "POST",
        data: {
            email: email
        },
        success: function (content) {
            var popin = extract_value(content, 'POPIN');
            $('#popin_modal_lg_content').html(popin);
            initInputs();
        }
    });
}

$('.filter_menu_value_label').click(function () {
    console.log('click');
    setTimeout(function () {
        $('.filter-counter').html($('.filter_selected').length);
    }, 100);
});

//fix for anime arrow on collapse
$('.collapse').on('show.bs.collapse', function () {
    $('.collapser').addClass('active');
});
$('.collapse').on('hide.bs.collapse', function () {
    $('.collapser').removeClass('active');
});

function validateAccountForm() {
    $('form[data-validation]').each(function () {
        if ($(this).data('validation') == true) {
            $(this).validate({
                errorElement: "span",
                errorClass: "invalid",
                ignore: ".ignore",
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                    //error.insertAfter(element).insertAfter(".bar");
                },
                /*errorPlacement: function (error, element) {
                    error.insertAfter(".bar");
                    //return true;
                    if (element.attr("name") == "account_birthday")
                    error.insertAfter(".checked");
                },*/
                onfocusout: function (element) {
                    this.element(element);
                },
                onkeyup: function (element) {
                    this.element(element);
                },
                messages: messageValidateAccountForm,
                rules: rulesValidateAccountForm
            });
        }
    });
}

var rulesValidateAccountForm = {
    account_email: {
        required: true,
        email: true,
        nowhitespace: true
    },
    account_password: {
        required: true,
        minlength: 8,
        nowhitespace: true,
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/
    },
    account_password2: {
        required: true,
        minlength: 8,
        nowhitespace: true,
        equalTo: '#createaccount_password',
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/
    },
    account_lastname: {
        required: true,
        minlength: 2,
        pattern: /^[^\s]/
    },
    account_firstname: {
        required: true,
        minlength: 2,
        pattern: /^[^\s]/
    },
    account_adr1: {
        required: true,
        pattern: /^[^\s]/
    },
    createaccount_zipcode: {
        required: true,
        nowhitespace: true,
        pattern: /^(0[1-9]|[1-9][0-9])[0-9]{3}$/
    },
    createaccount_city: {
        required: true,
        pattern: /^[^\s]/
    },
    createaccount_mobile: {
        required: true,
        pattern: /^0(1|2|3|4|5|8|9)[0-9]{8}$|^0(6|7)[0-9]{8}$|^$/
    },
    account_birthday: {
        required: true,
        nowhitespace: true,
        majeur: true
    },
    password: {
        required: true,
        minlength: 8,
        nowhitespace: true,
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/
    },
    password2: {
        required: true,
        minlength: 8,
        nowhitespace: true,
        equalTo: '#createaccount_password',
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,}$/
    }
};

var messageValidateAccountForm = {
    account_email: {
        required: 'Veuillez indiquer une adresse email valide.',
        email: 'Veuillez indiquer une adresse email valide.',
        nowhitespace: 'Votre mot de passe ne doit pas comporter d\'espace.',
    },
    account_password: {
        required: 'Votre mot de passe doit comporter au moins 8 caractères.',
        minlength: 'Votre mot de passe doit comporter au moins 8 caractères.',
        nowhitespace: 'Votre mot de passe ne doit pas comporter d\'espace.',
        pattern: 'Le mot de passe doit avoir une longueur minimale de 8 caractères, comporter au moins une majuscule, un caractère spécial (@$!%*?&) et un chiffre.',
    },
    account_password2: {
        required: 'Votre mot de passe doit comporter au moins 8 caractères.',
        minlength: 'Votre mot de passe doit comporter au moins 8 caractères.',
        nowhitespace: 'Votre mot de passe ne doit pas comporter d\'espace.',
        equalTo: 'Les mots de passe sont différents.',
        pattern: 'Le mot de passe doit avoir une longueur minimale de 8 caractères, comporter au moins une majuscule, un caractère spécial (@$!%*?&) et un chiffre.',
    },
    account_lastname: {
        required: 'La saisie de votre nom de famille est obligatoire.',
        minlength: 'La saisie de votre nom de famille doit avoir une longueur minimale de 2 caractères',
        pattern: 'La saisie de votre nom de famille est incorrecte.'
    },
    account_firstname: {
        required: 'La saisie de votre prénom est obligatoire.',
        minlength: 'La saisie de votre prénom doit avoir une longueur minimale de 2 caractères',
        pattern: 'La saisie de votre prénom est incorrecte.'
    },
    account_adr1: {
        required: 'Vous devez saisir votre adresse.',
        pattern: 'La saisie de votre adresse est incorrecte.'
    },
    createaccount_zipcode: {
        required: 'Vous devez saisir votre code postal.',
        nowhitespace: 'Votre code postal ne doit pas comporter d\'espace.',
        pattern: 'La saisie de votre code postal est incorrecte.'
    },
    createaccount_city: {
        required: 'La saisie de votre ville est obligatoire.',
        pattern: 'La saisie de votre ville est incorrecte.'
    },
    createaccount_mobile: {
        required: 'Vous devez saisir votre numéro de téléphone.',
        pattern: 'Numéro de téléphone incorrect.'
    },
    account_birthday: {
        required: 'La saisie de votre date de naissance est obligatoire',
        nowhitespace: 'Votre date de naissance ne doit pas comporter d\'espace.',
        majeur: 'Vous devez avoir plus de 18 ans.'
    },
    password: {
        required: 'Votre mot de passe doit comporter au moins 8 caractères.',
        minlength: 'Votre mot de passe doit comporter au moins 8 caractères.',
        nowhitespace: 'Votre mot de passe ne doit pas comporter d\'espace.',
        pattern: 'Le mot de passe doit avoir une longueur minimale de 8 caractères, comporter au moins une majuscule, un caractère spécial (@$!%*?&) et un chiffre.'
    },
    password2: {
        required: 'Votre mot de passe doit comporter au moins 8 caractères.',
        minlength: 'Votre mot de passe doit comporter au moins 8 caractères.',
        nowhitespace: 'Votre mot de passe ne doit pas comporter d\'espace.',
        equalTo: 'Les mots de passe sont différents.',
        pattern: 'Le mot de passe doit avoir une longueur minimale de 8 caractères, comporter au moins une majuscule, un caractère spécial (@$!%*?&) et un chiffre.'
    }
};

function onSubmitFormContact() {
    $('form[name="contactForm"]').submit();
}

function addFavorite(codepro, proref, codbar) {
    $.ajax({
        url: "ajaxeshop/addArticleToFavorite",
        type: "POST",
        data: {
            codepro: codepro,
            proref: proref,
            codbar: codbar
        },
        success: function (content) {
            var popin = extract_value(content, 'POPIN');
            $('#popin_modal_lg_content').html(popin);
        }
    });
}

function showCoordonneesHoraires() {
    $.ajax({
        url: "ajaxeshop/showCoordonneesHoraires",
        type: "POST",
        data: {},
        success: function (content) {
            var popin = extract_value(content, 'POPIN');
            $('#popin_modal_lg_content').html(popin);
        }
    })
}

function addCommentPopin(codepro) {
    $.ajax({
        url: "ajaxeshop/addCommentPopin",
        type: "POST",
        data: {
            codepro: codepro
        },
        success: function (content) {
            var popin = extract_value(content, 'POPIN');
            $('#popin_modal_lg_content').html(popin);
            initInputs();
        }
    })
}

function getRating(note){
    $("#note_comment").val(note);
}

function activeNav() {
    $('nav div ul li a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('active');
}

//show/hide header
if ($(window).width() < 1200) {
    var header = document.getElementById("header");
    var hamburger = document.getElementById("hamburger");
    var headerHeight = header.offsetHeight;
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos || currentScrollPos < 160) {
            header.style.top = "0";
            hamburger.style.top = "0";
        } else {
            header.style.top = -headerHeight + "px";
            hamburger.style.top = -headerHeight + "px";
        }
        prevScrollpos = currentScrollPos;
    }
}

function addWorkshopCart(workshopId)
{
    loading();

    $.ajax({
        url: "ajaxeshop/addworkshopcart",
        type: "POST",
        data: {'workshop_id': workshopId},
        success: function (data) {
            var redirect = extract_value(data, 'REDIRECT');
            if (redirect !== '') {
                document.location.href = redirect;
            }
            loadout();
        },
        error: function (xhr, status, error) {
            loadout();
        }
    });
}

function getWorkshopParticipants()
{
    var participants = new Object();
    if ($('#participantsContainer').length) {

        $('.workshop-participants').each(function(){
            let val = $(this).val();
            let key = $(this).data('key');
            let i   = $(this).data('i');

            if (typeof(participants[i]) == 'undefined') {
                participants[i] = new Object();
            }
            participants[i][key] = val;
        });
    }
    return participants;
}

function setWorkshopParticipants(json)
{
    try {
        var participants = JSON.parse(json);
        if ($('#participantsContainer').length) {
            $('.workshop-participants').each(function(){
                let key = $(this).data('key');
                let i   = $(this).data('i');
    
                if (typeof(participants[i]) != 'undefined' && typeof participants[i][key] != 'undefined') {
                    $(this).val(participants[i][key]);
                }
            });
        }
    } catch(e) {
        console.log(e);
    }
}


function valid_workshop()
{
    if ($('#participantsContainer').length) {
        var error = false;
        $('#participantsContainer .workshop-participants').each(function(){
            if (typeof $(this).val() == 'undefined' || $(this).val() == '') {
                error = true;
            }
        });

        if (error === false) {
            if ($('#check_cgv').is(':checked')) {
                loading();
                var participants = getWorkshopParticipants();
                participants = JSON.stringify(participants);

                $.ajax({
                    url: "ajaxeshop/setWorkshopParticipants",
                    type: "POST",
                    data: {
                        'id_order': $('#id_order').val(),
                        'participants': participants,
                    },
                    success: function (data) {
                        var status  = extract_value(data, 'STATUS');
                        var message = extract_value(data, 'MESSAGE');

                        if (status == 'OK') {
                            //Récupération du moyen de paiement actuellement sélectionné
                            var payment_method = $('input[name=payment]:checked').val();
                            
                            //Traitement spécifique ATOS SIPS
                            if (payment_method == 'CBATOS') {
                                //Récupération du code CB sélectionné
                                var cbcode = $('input[name=atos_select_cb]:checked').val();
                    
                                //Validation du formulaire ATOS caché, retourné par l'api ATOS
                                $('#form_payment_CBATOS input[name=' + cbcode + ']').click();
                            }
                            //TRAITEMENT WORLDPAY
                            else if (payment_method == 'WORLDPAY') {
                                //Loading
                                loading();
                                $('#button_valid_order').hide();
                                $('#place-order').click();
                            }
                            else {
                                //Loading + effacement du bouton pour éviter les doubles paiement
                                loading();
                                $('#button_valid_order').hide();
                    
                                //Et validation du formulaire
                                $('#form_payment_' + payment_method).submit();
                            }
                        } else {
                            if (message !== '') {
                                jAlert(message, gettxt('JS_ESHOP_ALERT_WORKSHOP_TITLE'));
                            }
                        }
                        loadout();
                    },
                    error: function (xhr, status, error) {
                        loadout();
                    }
                });
            } else {
                jAlert(gettxt('JS_ESHOP_ALERT_ACCEPT_CVG'), gettxt('JS_ESHOP_ALERT_ACCEPT_CVG_TITLE'));
            }
        } else {
            jAlert(gettxt('JS_ESHOP_ALERT_WORKSHOP_MISSING_PARTICIPANTS'), gettxt('JS_ESHOP_ALERT_WORKSHOP_TITLE'));
        }
    } else {
        jAlert(gettxt('JS_ESHOP_ALERT_WORKSHOP_ERROR_PARTICIPANTS'), gettxt('JS_ESHOP_ALERT_WORKSHOP_TITLE'));
    }
}

window.initInputs              = initInputs;
window.deleteFromWishList      = deleteFromWishList;
window.checkThisInput          = checkThisInput;
window.initSelects             = initSelects;
window.showNewsletterPopin     = showNewsletterPopin;
window.validateAccountForm     = validateAccountForm;
window.onSubmitFormContact     = onSubmitFormContact;
window.addFavorite             = addFavorite;
window.showCoordonneesHoraires = showCoordonneesHoraires;
window.addCommentPopin         = addCommentPopin;
window.getRating               = getRating;
window.addWorkshopCart         = addWorkshopCart;
window.getWorkshopParticipants = getWorkshopParticipants;
window.setWorkshopParticipants = setWorkshopParticipants;
window.valid_workshop          = valid_workshop;
window.deleteFromWishListStep  = deleteFromWishListStep;